import mapFunction from './mapResources';

export default mapFunction('building_top_entities', {
    isFetching: false,
    items: []
});